<template>

    <div class="form-group ast">
        <label
            for="field-nname"
            class="control-label"
        >
            {{ lang('all.jouw_naam') }}
        </label>

        <input
            type="text"
            class="form-control"
            id="field-nname"
            @input="$emit('input', $event.target.value)"
            :value="value"
        />
    </div>

</template>

<script>

export default {

    name:'ContactformTypesAntispamtype',

    props: {
        value: {
            required:true,
        },
    },
}

</script>
